module.exports = __webpack_public_path__ + "media/images/salesforce-8a2975566b8814990c907964fbf14d35.svg";